module.exports = __webpack_public_path__ + "img/plan-02-m.19ce5438.png";